// Helpers compartidos del flujo de envío de correo (EnviarCorreoModal y
// sus piezas). Fechas de los presets de programación + formato de tamaños
// + límites de adjuntos SMTP (coordinados con api/correos_adjuntos.py).

// --- Programar envio: presets tipo Gmail ---
export function aLasHoras(base: Date, h: number): Date {
  const d = new Date(base);
  d.setHours(h, 0, 0, 0);
  return d;
}

export function manana(h: number): Date {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return aLasHoras(d, h);
}

export function proximoLunes(h: number): Date {
  const d = new Date();
  let add = (8 - d.getDay()) % 7; // dias hasta el proximo lunes
  if (add === 0) add = 7;
  d.setDate(d.getDate() + add);
  return aLasHoras(d, h);
}

export function fmtFechaCorta(d: Date): string {
  return d.toLocaleString([], {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function minProgramable(): string {
  const d = new Date(Date.now() + 5 * 60000);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 16);
}

// Limites del adjunto SMTP. Coordinados con el backend (correos_adjuntos.py).
export const MAX_ADJUNTO_BYTES = 10 * 1024 * 1024;
export const MAX_TOTAL_ADJUNTOS_BYTES = 15 * 1024 * 1024;

// Vive en lib/formato; se re-exporta para no tocar a los que ya lo importan de aquí.
export { fmtMB } from "@/lib/formato";


// Espejo de arktickets/domain/adjuntos.ALLOWED_MIMES_ADJUNTO — mantener en sync.
export const ALLOWED_MIMES_ADJUNTO = new Set<string>([
  "application/pdf",
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/gif",
  "image/webp",
  "application/zip",
  "application/x-zip-compressed",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "text/csv",
  "text/plain",
]);

// ¿Se puede adjuntar esta evidencia directo (sin ZIP)? Espejo de la regla pura
// del backend (domain/adjuntos.evidencia_adjuntable).
export function evidenciaAdjuntable(ev: {
  mime: string;
  size_bytes: number;
  archivo_eliminado_at?: string | null;
}): { ok: boolean; motivo?: "pesada" | "tipo" | "purgada" } {
  if (ev.archivo_eliminado_at) return { ok: false, motivo: "purgada" };
  if (!ALLOWED_MIMES_ADJUNTO.has(ev.mime)) return { ok: false, motivo: "tipo" };
  if (ev.size_bytes > MAX_ADJUNTO_BYTES) return { ok: false, motivo: "pesada" };
  return { ok: true };
}
